export const FOREIGN_QUALIFICATION_PRICING_TIER_STANDARD = "STANDARD";
export const FOREIGN_QUALIFICATION_PRICING_TIER_PRIORITY = "PRIORITY";

export type ForeignQualificationPricingTier =
  | typeof FOREIGN_QUALIFICATION_PRICING_TIER_STANDARD
  | typeof FOREIGN_QUALIFICATION_PRICING_TIER_PRIORITY;

export const FOREIGN_QUALIFICATION_PRICING_TIER_OPTIONS = [
  { value: FOREIGN_QUALIFICATION_PRICING_TIER_STANDARD, label: "Standard" },
  { value: FOREIGN_QUALIFICATION_PRICING_TIER_PRIORITY, label: "Priority" },
];

export const FOREIGN_QUALIFICATION_PRICING_TIER_TURNAROUND: Record<
  ForeignQualificationPricingTier,
  string
> = {
  [FOREIGN_QUALIFICATION_PRICING_TIER_STANDARD]:
    "Usually takes 3-5 days, depending on information needed by the state",
  [FOREIGN_QUALIFICATION_PRICING_TIER_PRIORITY]: "Usually takes 1-3 days",
};
